var $ = require('jquery');

window.ssm.tabs = function (el) {
	'use strict';

	var panels = [];

	$('li', el).each(function() {
		var $this = $(this);

		var controls = $this.attr('aria-controls');
		var selected = $this.attr('aria-selected');

		var panel = $(document.getElementById(controls));
		panel.attr('aria-hidden', selected);
		if(! selected || selected === 'false') {
			panel.addClass('tab-inactive').attr('aria-hidden', 'true');
		} else {
			panel.removeClass('tab-inactive').attr('aria-hidden', 'false');
		}

		panels.push({
			tab: $this,
			panel: panel
		});
	});

	var switchTo = function(el) {
		var controls = $(el).attr('aria-controls');
		for(var i=0; i<panels.length; i++) {
			var p = panels[i];
			if(p.panel.attr('id') === controls) {
				p.panel.removeClass('tab-inactive').attr('aria-hidden', 'false');
				p.tab.attr('aria-selected', 'true');
			} else {
				p.panel.addClass('tab-inactive').attr('aria-hidden', 'true');
				p.tab.attr('aria-selected', 'false');
			}
		}
	};

	$(el).on('click', 'li[aria-controls]', function(e) {
		e.preventDefault();
		switchTo(this);
	}).on('keydown', 'li[aria-controls]', function(e) {
		if(e.keyCode === 13) {
			e.preventDefault();
			switchTo(this);
		}
	});
};
